import { IconComponent } from './types';

const PolygonIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path stroke="currentColor" d="M.5.5h11v11H.5z" />
  </svg>
);

export default PolygonIcon;
